import { render, staticRenderFns } from "./fontSizeController.vue?vue&type=template&id=5bb7162c&"
import script from "./fontSizeController.vue?vue&type=script&lang=ts&"
export * from "./fontSizeController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports